import {
  formatDateMMddYYYY,
  MetricProgressBar,
  toProgressSegments,
} from '../utils/utils';
import {
  ProgressPortraitMetrics,
  TreatmentImpactIndicator,
} from '../model/ProgressPortrait';
import { CellData, ProgressBar } from './ProgressBar';
import { CellTooltip, TooltipItem } from './CellTooltip';

const tiisExtractor = (progressPortraitMetrics: ProgressPortraitMetrics) =>
  progressPortraitMetrics.tiis ?? [];

const toCellData = (tiisData: TreatmentImpactIndicator): CellData => {
  const tooltip = <TreatmentImpactTooltip tiis={tiisData} />;
  if (
    tiisData.treatment_Impact_Indicator_Type__c ===
    'Family Treatment Impact Indicator'
  ) {
    if (tiisData.total_Score__c >= 20 && tiisData.total_Score__c <= 25) {
      return {
        label: 'Significant Impact',
        level: 'high',
        tooltip,
      };
    }
    if (tiisData.total_Score__c >= 15 && tiisData.total_Score__c <= 19) {
      return {
        label: 'Some Positive Impact',
        level: 'medium',
        tooltip,
      };
    }
    if (tiisData.total_Score__c <= 14) {
      return {
        label: 'Little/No Positive Impact',
        level: 'low',
        tooltip,
      };
    }
  } else {
    if (tiisData.total_Score__c >= 16 && tiisData.total_Score__c <= 20) {
      return {
        label: 'Significant Impact',
        level: 'high',
        tooltip,
      };
    }
    if (tiisData.total_Score__c >= 12 && tiisData.total_Score__c <= 15) {
      return {
        label: 'Some Positive Impact',
        level: 'medium',
        tooltip,
      };
    }
    if (tiisData.total_Score__c <= 11) {
      return {
        label: 'Little/No Positive Impact',
        level: 'low',
        tooltip,
      };
    }
  }
  return {
    label: 'N/A',
    level: 'NA',
    tooltip,
  };
};

const sortedComparator = (
  point1: TreatmentImpactIndicator,
  point2: TreatmentImpactIndicator,
) => point1.assessment_Date__c.valueOf() - point2.assessment_Date__c.valueOf();

export const TreatmentImpactMetric = ({
  progressPortraitMetrics,
}: MetricProgressBar) => {
  const segments = toProgressSegments(
    progressPortraitMetrics,
    tiisExtractor,
    toCellData,
    sortedComparator,
  );
  return <ProgressBar segments={segments} />;
};

const TreatmentImpactTooltip = ({
  tiis,
}: {
  tiis: TreatmentImpactIndicator;
}) => {
  let text = 'N/A';

  if (
    tiis.treatment_Impact_Indicator_Type__c ===
    'Family Treatment Impact Indicator'
  ) {
    if (tiis.total_Score__c >= 20 && tiis.total_Score__c <= 25) {
      text = 'Significant Impact';
    } else if (tiis.total_Score__c >= 15 && tiis.total_Score__c <= 19) {
      text = 'Some Positive Impact';
    } else if (tiis.total_Score__c <= 14) {
      text = 'Little/No Positive Impact';
    }
  } else {
    if (tiis.total_Score__c >= 16 && tiis.total_Score__c <= 20) {
      text = 'Significant Impact';
    } else if (tiis.total_Score__c >= 12 && tiis.total_Score__c <= 15) {
      text = 'Some Positive Impact';
    } else if (tiis.total_Score__c <= 11) {
      text = 'Little/No Positive Impact';
    }
  }

  const info: TooltipItem[] = [
    {
      label: 'Tx Impact Indicator Date:',
      value: formatDateMMddYYYY(tiis.assessment_Date__c),
    },
    {
      label: 'Tx Impact Indicator Type:',
      value: tiis.treatment_Impact_Indicator_Type__c,
    },
    {
      label: 'Tx Impact Indicator Score:',
      value: `${tiis.total_Score__c} (${text})`,
    },
    {
      label: 'Respondent:',
      value: tiis.name_Of_Respondent__c,
    },
  ];
  return <CellTooltip info={info} />;
};
